import { SalesforceField } from 'model/SalesforceField';
import { useEffect } from 'react';
import { useFormContext } from 'components/Generic/Forms/SalesforceIntegratedForms/FormContext';

const SalesforceHiddenField = ({ fields }: SalesforceField) => {
  const { updateFormData, setHiddenFields } = useFormContext();
  useEffect(() => {
    updateFormData({
      fieldName: fields.salesforceFieldId.value,
      value: fields.salesforceValue.value,
    });
    setHiddenFields((prev) => [...prev, fields.salesforceFieldId.value]);
  }, [fields.salesforceFieldId.value, fields.salesforceValue.value, updateFormData]);
  return (
    fields.includeInMarkup.value && (
      <input
        type="hidden"
        aria-hidden="true"
        tabIndex={0}
        style={{
          opacity: 0,
          position: 'absolute',
          top: 0,
          left: 0,
          height: 0,
          width: 0,
          zIndex: -1,
        }}
      />
    )
  );
};

export default SalesforceHiddenField;
